import React, { useState } from 'react';
import { Download } from 'lucide-react';
import { Button } from '../ui/button';
import { toast } from 'sonner';
import api from '../../lib/api';

const escapeCsv = (v) => {
  const s = String(v ?? '');
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

export const ExportCsvButton = ({ endpoint, filename, columns, label = 'Download Spreadsheet', testId }) => {
  const [busy, setBusy] = useState(false);

  const download = async () => {
    setBusy(true);
    try {
      const { data } = await api.get(endpoint);
      if (!data?.length) {
        toast.info('Nothing to export yet.');
        return;
      }
      const header = columns.map((c) => escapeCsv(c.label)).join(',');
      const rows = data.map((row) => columns.map((c) => escapeCsv(c.value ? c.value(row) : row[c.key])).join(','));
      const blob = new Blob([`${header}\n${rows.join('\n')}`], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
      toast.success(`Downloaded ${filename} (${data.length} rows)`);
    } catch {
      toast.error('Export failed — please try again.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button
      onClick={download}
      disabled={busy}
      variant="outline"
      size="sm"
      data-testid={testId}
      className="border-[#5d6b3c] text-[#5d6b3c] hover:bg-[#5d6b3c] hover:text-white"
    >
      <Download className="w-4 h-4 mr-2" />
      {busy ? 'Preparing…' : label}
    </Button>
  );
};
